<div class="flex flex-col gap-2 p-3" [hsLayer]="'one'">
  <div class="header">{{ dialogTitle }}</div>
  <hs-divider></hs-divider>
  <div class="flex flex-row gap-2 ml-2">
    <input
      type="radio"
      id="offer"
      name="sales_item"
      [value]="KfmProcessType.Offer"
      [(ngModel)]="selectedProcessType"
    />
    <label for="offer">{{ offerLabel }}</label>
  </div>

  <div class="flex flex-row gap-2 ml-2">
    <input
      type="radio"
      id="task"
      name="sales_item"
      [value]="KfmProcessType.Order"
      [(ngModel)]="selectedProcessType"
    />
    <label for="task">{{ taskLabel }}</label>
  </div>

  <div class="flex flex-row gap-2 ml-2">
    <input
      type="radio"
      id="invoice"
      name="sales_item"
      [value]="KfmProcessType.Invoice"
      [(ngModel)]="selectedProcessType"
    />
    <label for="invoice">{{ invoiceLabel }}</label>
  </div>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(selectedProcessType)"
    >
      {{ yesLabel }}
    </button>
  </div>
</div>
